<div class="back-layer ">
  <div class="modal">
    <div class="close">
      <i class="pi pi-times"  (click)="closeModal()"></i>
    </div>
    <div class="head">
      <h3>{{ question }}</h3>
    </div>
    <div class="body">
      <h5>{{ content }}</h5>
    </div>
    <div class="foot">
      <button class="btn-text-icon sure" (click)="emit(objectId)"> <i class="pi pi-check"></i> Sure </button>
      <button class="btn-text-icon cancel" (click)="closeModal()"> <i class="pi pi-times"></i> Cancel </button>
    </div>
  </div>
</div>